export var PHI_MASK = '****************';
/**
 * Describe
 * @param {any} unmaskedData:any
 * @param {boolean} containsPhi defaulted to true
 * @returns string | any
 * @Throws a TypeError ("cyclic object value") exception when a circular reference is found.
 * @Throws a TypeError ("BigInt value can't be serialized in JSON") when trying to stringify a BigInt value.
 */
export function maskPhi(unmaskedData, containsPhi) {
    if (containsPhi === void 0) { containsPhi = true; }
    if (checkShouldMask(containsPhi, unmaskedData)) {
        return PHI_MASK;
    }
    var mask = function (key, value) { return maskField(containsPhi, key, value); };
    return JSON.stringify(unmaskedData, mask);
}
function maskField(containsPhi, key, value) {
    if (isJSON(value)) {
        // eslint-disable-next-line no-param-reassign
        value = JSON.parse(value);
    }
    if (checkShouldMask(containsPhi, value, key)) {
        return PHI_MASK;
    }
    return value;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function checkShouldMask(containsPhi, value, key) {
    if (key === void 0) { key = ''; }
    if (containsPhi === null) {
        // eslint-disable-next-line no-param-reassign
        containsPhi = true;
    }
    return containsPhi && !isGuid(value) && !isJSON(value) && typeof value !== typeof {}; // Parse further
}
export function isGuid(value) {
    if (typeof value === typeof '') {
        var regexp = /^[\da-f]{8}-[\da-f]{4}-[0-5][\da-f]{3}-[089ab][\da-f]{3}-[\da-f]{12}$/i;
        return regexp.test(value);
    }
    return false;
}
export function isJSON(value) {
    try {
        if (value && JSON.parse(value) && typeof JSON.parse(value) === typeof {}) {
            return true;
        }
    }
    catch (_a) {
        return false;
    }
    return false;
}
